import React from 'react'

import { useNavigate } from 'react-router-dom'

import { EVENTS } from '../../routes'
import { IEvent } from '../../store/events/interfaces'
import { Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { RegisterButton } from '../shared/RegisterButton'

export const EventActions = (props: {
  event: IEvent
}) => {
  const { event } = props

  const isExternal = event.has_external_registration;
  const hasExternalDescription = event.external_registration_description_html && event.external_registration_description_html.trim();

  const navigate = useNavigate()
  return (
    <Col md={12} className='pl-0'>
      <RegisterButton event={event} editable={true} extraClasses='btn mb-2 w-100'/>
      {(isExternal && hasExternalDescription) || !isExternal ? (
        <button
          className='btn btn-outline-dark w-100 h-100 d-flex align-items-center justify-content-center'
          onClick={() => navigate(`${EVENTS.path}/${event.event_id}?highlight=external-registration`)}
        >
          {isExternal ? (
              <>
              Mehr Erfahren
              </>
            ) : (
              <>
                <FontAwesomeIcon icon='info-circle' role='presentation' />
                &nbsp;Details
              </>
          )}
        </button>
      ) : null}
    </Col>
  )
}
